const SITE_URL = "https://ustaad.today";

export type ComputerSchemaLink = {
  name: string;
  path: string;
};

const toAbsoluteUrl = (path: string) => {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${SITE_URL}${path}`;
};

export const buildComputerItemList = (items: ComputerSchemaLink[]) => ({
  "@type": "ItemList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    url: toAbsoluteUrl(item.path),
  })),
});

export const buildComputerNamedItemList = (items: string[]) => ({
  "@type": "ItemList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item,
  })),
});

export const buildComputerCollectionSchema = (config: {
  about: string;
  items: ComputerSchemaLink[];
  educationalLevel?: string;
}) => ({
  about: {
    "@type": "Thing",
    name: config.about,
  },
  audience: {
    "@type": "EducationalAudience",
    educationalRole: "student",
  },
  educationalLevel: config.educationalLevel ?? "11th class",
  isAccessibleForFree: true,
  mainEntity: buildComputerItemList(config.items),
  hasPart: config.items.map((item) => ({
    "@type": "WebPage",
    name: item.name,
    url: toAbsoluteUrl(item.path),
  })),
});
